// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  token: __t.string().primaryKey(),
  inviter: __t.identity(),
  worldId: __t.u64().name("world_id"),
  x: __t.f32(),
  z: __t.f32(),
  uses: __t.u16(),
  maxUses: __t.u16().name("max_uses"),
  createdAt: __t.timestamp().name("created_at"),
  expiresAt: __t.timestamp().name("expires_at"),
});
